import L from 'leaflet';

const MARKER_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
  <path d="M21 0C29.8364 0 36.9998 7.15991 37 15.9922C37 21.1483 32.9296 27.8417 25.0205 36.0127L23.7393 37.3154C23.302 37.7535 22.8539 38.1954 22.3955 38.6416L21 40L18.9248 37.9756C18.7009 37.7545 18.4794 37.5345 18.2607 37.3154L16.9795 36.0127C9.0704 27.8417 5 21.1483 5 15.9922C5.00022 7.15991 12.1636 0 21 0ZM21 8.49316C16.8579 8.49316 13.5 11.851 13.5 15.9932C13.5002 20.1351 16.858 23.4932 21 23.4932C25.142 23.4931 28.4998 20.1351 28.5 15.9932C28.5 11.851 25.1421 8.49319 21 8.49316Z" fill="#85654D"/>
</svg>`;

function buildMarkerIcon() {
  return L.divIcon({
    html: MARKER_SVG,
    className: '',
    iconSize: [40, 40],
    iconAnchor: [20, 40],
  });
}

/**
 * Initialises a small, decorative Leaflet/OSM map inside each `.js-map-image-card`
 * element that has valid `data-lat` / `data-lng` attributes.
 *
 * The map is intentionally non-interactive (no drag, no scroll zoom, no controls)
 * because it acts as a visual replacement for the previous static Google Maps image.
 * Users open the full map via the OSM link button rendered by map-image.php.
 */
export function initMapImages(root = document) {
  const cards = root.querySelectorAll('.js-map-image-card');

  cards.forEach((card) => {
    if (card.dataset.initialized === 'true') return;
    card.dataset.initialized = 'true';

    const mapEl = card.querySelector('.js-map-image-leaflet');
    if (!mapEl) return;

    const lat = parseFloat(card.dataset.lat);
    const lng = parseFloat(card.dataset.lng);
    const zoom = parseInt(card.dataset.zoom, 10) || 15;

    if (isNaN(lat) || isNaN(lng)) return;

    const map = L.map(mapEl, {
      center: [lat, lng],
      zoom,
      dragging: false,
      scrollWheelZoom: false,
      doubleClickZoom: false,
      zoomControl: false,
      keyboard: false,
      tap: false,
      attributionControl: true,
    });

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a>',
      maxZoom: 19,
    }).addTo(map);

    L.marker([lat, lng], { icon: buildMarkerIcon() }).addTo(map);
  });
}
